import { EmojiPluginInterface } from './plugin/EmojiPlugin';
import emojiPluginTrigger from './utils/emojiPluginTrigger';
import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "EmojiPlugin" */ './lazyIndex')
);

export let LazyEmojiPluginClass = createLazyPlugin(
    lazyModule,
    m => m.EmojiPlugin,
    'Emoji',
    emojiPluginTrigger
);

// Types
export { LazyPlugin, EmojiPluginInterface };
